/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_TotalInputs */

const cs_billing_total = /** @type {(inputs: Billing_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem dostupně`)
};

const en_billing_total = /** @type {(inputs: Billing_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total available`)
};

/**
* | output |
* | --- |
* | "Total available" |
*
* @param {Billing_TotalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_total = /** @type {((inputs?: Billing_TotalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_TotalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_total(inputs)
	return cs_billing_total(inputs)
});